import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Galeria.css';

const images = [
  { src: '/images/foto1.webp', alt: 'Camión de DanPauleX en ruta' },
  { src: '/images/foto2.webp', alt: 'Camión de DanPauleX durante un transporte' },
  { src: '/images/foto3.webp', alt: 'Vehículo de DanPauleX preparado para la carga' }
];

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true
};

function Galeria() {
  // Precarga: cada foto termina como 'ok' o 'error'; nunca se queda esperando.
  const [estado, setEstado] = useState({});
  const terminadas = Object.keys(estado).length;
  const visibles = images.filter((img) => estado[img.src] === 'ok');

  const marcar = (src, resultado) => () =>
    setEstado((prev) => (prev[src] ? prev : { ...prev, [src]: resultado }));

  if (terminadas < images.length) {
    return (
      <div className="galeria-solo-fotos">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <p>Cargando galería...</p>
          {images.map((img) => (
            <img
              key={img.src}
              src={img.src}
              alt=""
              onLoad={marcar(img.src, 'ok')}
              onError={marcar(img.src, 'error')}
              style={{ display: 'none' }}
            />
          ))}
        </div>
      </div>
    );
  }

  if (!visibles.length) return null;

  return (
    <div className="galeria-solo-fotos">
      <Slider {...settings} infinite={visibles.length > 1}>
        {visibles.map((img) => (
          <div key={img.src}>
            <img src={img.src} alt={img.alt} />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Galeria;
